import React, { useMemo } from 'react';
import { Col, Row } from 'components';
import { DownOutlined } from '@ant-design/icons';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import { SummaryDescription } from './SummaryDescription';
import { useGeneral } from './useGeneral';
import { Button, Dropdown, MenuProps, Space } from 'antd';
import { StatusBadge, StatusType } from 'components/common/StatusBadge';
import { ChangeStatusMapping } from 'models/Task';
import { TaskComments } from './Comments';
import styles from './styles.module.scss';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { useParams } from 'react-router-dom';

export const TaskGeneral = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { id } = useParams() as { id: string };
  const { form, editMode, setEditMode, taskDetails, onUpdate, handleStatusChange } = useGeneral();

  const changeStatusMenu: MenuProps['items'] = useMemo(() => {
    const availableOptions = ChangeStatusMapping[taskDetails.status] || [];

    return availableOptions.map((i: { label: string; value: StatusType }) => ({
      label: <StatusBadge type={i.value} tooltip={i.label} />,
      key: i.value,
    }));
  }, [taskDetails]);

  return (
    <Row wrap={false} className={styles.general} justify={'space-between'}>
      <Col>
        <Row className={styles.scroll_cont}>
          <Col className={styles.comments_scroll}>
            <Row gutter={[0, 32]} className={styles.scroll_container}>
              <Col span={24}>
                <SummaryDescription
                  editMode={editMode}
                  form={form}
                  onUpdate={onUpdate}
                  setEditMode={setEditMode}
                  id={id}
                />
              </Col>
              <Col span={24}>
                <TaskComments hasAccessToWrite={hasAccess(PERMISSIONS.tasks.task.write)} id={id} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col>
        <HasAccess role={PERMISSIONS.tasks.task.write}>
          <Dropdown
            menu={{
              items: changeStatusMenu,
              onClick: ({ key }) => {
                handleStatusChange(key as StatusType);
              },
            }}
            trigger={['click']}
          >
            <Button className={styles.status_btn}>
              <Space>
                Change Status
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>
        </HasAccess>
      </Col>
    </Row>
  );
});
